

// document.addEventListener('DOMContentLoaded', function() {
//   alert("hello nirali");
//    var countryDropdown = document.getElementById('Select2');

//    // Set the default value to 'USA'
//    countryDropdown.value = 'US';

//    // Disable the dropdown
//    countryDropdown.setAttribute('disabled', 'true');
//  });

// document.addEventListener("DOMContentLoaded", function () {
//   $('#dogTable').DataTable({
//     responsive: true,
//     columnDefs: [
//       { responsivePriority: 1, targets: 0 },   // Priority for the first column
//       { responsivePriority: 2, targets: 1 },   // Priority for the second column
//       { responsivePriority: 3, targets: 2 },
//       // Add more columnDefs as needed
//     ]
//   });
// });

// document.addEventListener('DOMContentLoaded', function() {
//   var countryDropdown = document.getElementsByName('countryCode')[0]

//   // Set the default value to 'USA'
//   countryDropdown.value = 'US';

//   // Disable the dropdown
//   countryDropdown.setAttribute('disabled', 'true');
// });

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer, menu-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

// Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
//   this.countryEl = document.getElementById(country_domid);
//   this.provinceEl = document.getElementById(province_domid);
//   this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

//   Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

//   this.initCountry();
//   this.initProvince();
// };

// Shopify.CountryProvinceSelector.prototype = {
//   initCountry: function () {
//     var value = this.countryEl.getAttribute('data-default');
//     Shopify.setSelectorByValue(this.countryEl, value);
//     this.countryHandler();
//   },

//   initProvince: function () {
//     var value = this.provinceEl.getAttribute('data-default');
//     if (value && this.provinceEl.options.length > 0) {
//       Shopify.setSelectorByValue(this.provinceEl, value);
//     }
//   },

//   countryHandler: function (e) {
//     var opt = this.countryEl.options[this.countryEl.selectedIndex];
//     var raw = opt.getAttribute('data-provinces');
//     var provinces = JSON.parse(raw);

//     this.clearOptions(this.provinceEl);
//     if (provinces && provinces.length == 0) {
//       this.provinceContainer.style.display = 'none';
//     } else {
//       for (var i = 0; i < provinces.length; i++) {
//         var opt = document.createElement('option');
//         opt.value = provinces[i][0];
//         opt.innerHTML = provinces[i][1];
//         this.provinceEl.appendChild(opt);
//       }

//       this.provinceContainer.style.display = '';
//     }
//   },

//   clearOptions: function (selector) {
//     while (selector.firstChild) {
//       selector.removeChild(selector.firstChild);
//     }
//   },

//   setOptions: function (selector, values) {
//     for (var i = 0, count = values.length; i < values.length; i++) {
//       var opt = document.createElement('option');
//       opt.value = values[i];
//       opt.innerHTML = values[i];
//       selector.appendChild(opt);
//     }
//   },
// };
// edit code
// function populateProvinces(provinceDropdown, provinceContainer, savedProvince) {
//     clearOptions(provinceDropdown);

//     // Use the usStates array for populating provinces
//     for (var i = 0; i < usStates.length; i++) {
//         var opt = document.createElement('option');
//         opt.value = usStates[i][0];
//         opt.innerHTML = usStates[i][1];

//         // Check if the option matches the saved province
//         if (savedProvince && usStates[i][0] === savedProvince) {
//             opt.selected = true;
//         }

//         provinceDropdown.appendChild(opt);
//     }

//     provinceContainer.style.display = '';
// }

document.addEventListener("DOMContentLoaded", function () {
  var countryDropdowns = document.querySelectorAll(".address-country");
  var provinceDropdowns = document.querySelectorAll(".address-province");
  var provinceContainers = document.querySelectorAll(".province-container");
  var editButtons = document.querySelectorAll(".address-edit-button");

  // Set the default value for each country dropdown to 'US' and disable other options
  countryDropdowns.forEach(function (countryDropdown) {
    countryDropdown.value = "US";

    var countryOptions = countryDropdown.querySelectorAll("option");
    countryOptions.forEach(function (option) {
      if (option.value !== "US") {
        option.disabled = true;
      }
    });
  });

  // Trigger the countryHandler manually to populate provinces based on the default country
  countryHandler();

  function countryHandler() {
    countryDropdowns.forEach(function (countryDropdown, index) {
      var opt = countryDropdown.options[countryDropdown.selectedIndex];
      var selectedCountry = opt.value;

      // Check if the selected country is 'US'
      if (selectedCountry === "US") {
        var savedProvince = editButtons[index].getAttribute(
          "data-saved-province"
        );
        populateProvinces(
          provinceDropdowns[index],
          provinceContainers[index],
          savedProvince
        );
      } else {
        clearOptions(provinceDropdowns[index]);
        provinceContainers[index].style.display = "none";
      }
    });
  }

  function populateProvinces(
    provinceDropdown,
    provinceContainer,
    savedProvince
  ) {
    clearOptions(provinceDropdown);

    // Static list of U.S. states
    var usStates = [
      ["AL", "Alabama"],
      ["AK", "Alaska"],
      ["AZ", "Arizona"],
      ["AR", "Arkansas"],
      ["CA", "California"],
      ["CO", "Colorado"],
      ["CT", "Connecticut"],
      ["DE", "Delaware"],
      ["FL", "Florida"],
      ["GA", "Georgia"],
      ["HI", "Hawaii"],
      ["ID", "Idaho"],
      ["IL", "Illinois"],
      ["IN", "Indiana"],
      ["IA", "Iowa"],
      ["KS", "Kansas"],
      ["KY", "Kentucky"],
      ["LA", "Louisiana"],
      ["ME", "Maine"],
      ["MD", "Maryland"],
      ["MA", "Massachusetts"],
      ["MI", "Michigan"],
      ["MN", "Minnesota"],
      ["MS", "Mississippi"],
      ["MO", "Missouri"],
      ["MT", "Montana"],
      ["NE", "Nebraska"],
      ["NV", "Nevada"],
      ["NH", "New Hampshire"],
      ["NJ", "New Jersey"],
      ["NM", "New Mexico"],
      ["NY", "New York"],
      ["NC", "North Carolina"],
      ["ND", "North Dakota"],
      ["OH", "Ohio"],
      ["OK", "Oklahoma"],
      ["OR", "Oregon"],
      ["PA", "Pennsylvania"],
      ["RI", "Rhode Island"],
      ["SC", "South Carolina"],
      ["SD", "South Dakota"],
      ["TN", "Tennessee"],
      ["TX", "Texas"],
      ["UT", "Utah"],
      ["VT", "Vermont"],
      ["VA", "Virginia"],
      ["WA", "Washington"],
      ["WV", "West Virginia"],
      ["WI", "Wisconsin"],
      ["WY", "Wyoming"],
      // Add more states as needed
    ];

    // Use the usStates array for populating provinces
    for (var i = 0; i < usStates.length; i++) {
      var opt = document.createElement("option");
      opt.value = usStates[i][0];
      opt.innerHTML = usStates[i][1];

      // Check if the current province is the saved province and set it as selected
      if (usStates[i][0] === savedProvince) {
        opt.selected = true;
      }

      provinceDropdown.appendChild(opt);
    }

    provinceContainer.style.display = "";
  }

  function clearOptions(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  }

  // Attach the countryHandler to the change event for each country dropdown
  countryDropdowns.forEach(function (countryDropdown) {
    countryDropdown.addEventListener("change", countryHandler);
  });
});

//old edit code
// document.addEventListener('DOMContentLoaded', function () {

//     var countryDropdowns = document.querySelectorAll('.address-country');
//     var provinceDropdowns = document.querySelectorAll('.address-province');
//     var provinceContainers = document.querySelectorAll('.province-container');

//     // Extract the saved province from the data-default attribute
//     // var savedProvince = countryDropdowns[0].getAttribute('data-default');

//     // // Call populateProvinces with the saved province
//     // populateProvinces(provinceDropdowns[0], provinceContainers[0], savedProvince);

//     // Set the default value for each country dropdown to 'US' and disable other options
//     countryDropdowns.forEach(function (countryDropdown) {
//         countryDropdown.value = 'US';

//         var countryOptions = countryDropdown.querySelectorAll('option');
//         countryOptions.forEach(function (option) {
//             if (option.value !== 'US') {
//                 option.disabled = true;
//             }
//         });
//     });

//     var usStates = [
//         ['AL', 'Alabama'],
//         ['AK', 'Alaska'],
//         ['AZ', 'Arizona'],
//         ['AR', 'Arkansas'],
//         ['CA', 'California'],
//         ['CO', 'Colorado'],
//         ['CT', 'Connecticut'],
//         ['DE', 'Delaware'],
//         ['FL', 'Florida'],
//         ['GA', 'Georgia'],
//         ['HI', 'Hawaii'],
//         ['ID', 'Idaho'],
//         ['IL', 'Illinois'],
//         ['IN', 'Indiana'],
//         ['IA', 'Iowa'],
//         ['KS', 'Kansas'],
//         ['KY', 'Kentucky'],
//         ['LA', 'Louisiana'],
//         ['ME', 'Maine'],
//         ['MD', 'Maryland'],
//         ['MA', 'Massachusetts'],
//         ['MI', 'Michigan'],
//         ['MN', 'Minnesota'],
//         ['MS', 'Mississippi'],
//         ['MO', 'Missouri'],
//         ['MT', 'Montana'],
//         ['NE', 'Nebraska'],
//         ['NV', 'Nevada'],
//         ['NH', 'New Hampshire'],
//         ['NJ', 'New Jersey'],
//         ['NM', 'New Mexico'],
//         ['NY', 'New York'],
//         ['NC', 'North Carolina'],
//         ['ND', 'North Dakota'],
//         ['OH', 'Ohio'],
//         ['OK', 'Oklahoma'],
//         ['OR', 'Oregon'],
//         ['PA', 'Pennsylvania'],
//         ['RI', 'Rhode Island'],
//         ['SC', 'South Carolina'],
//         ['SD', 'South Dakota'],
//         ['TN', 'Tennessee'],
//         ['TX', 'Texas'],
//         ['UT', 'Utah'],
//         ['VT', 'Vermont'],
//         ['VA', 'Virginia'],
//         ['WA', 'Washington'],
//         ['WV', 'West Virginia'],
//         ['WI', 'Wisconsin'],
//         ['WY', 'Wyoming']
//         // Add more states as needed
//     ];

//     // Trigger the countryHandler manually to populate provinces based on the default country
//     countryHandler();

//     function countryHandler() {
//         countryDropdowns.forEach(function (countryDropdown, index) {
//             var opt = countryDropdown.options[countryDropdown.selectedIndex];
//             var selectedCountry = opt.value;

//             // Check if the selected country is 'US'
//             if (selectedCountry === 'US') {
//                 populateProvinces(provinceDropdowns[index], provinceContainers[index]);
//             } else {
//                 clearOptions(provinceDropdowns[index]);
//                 provinceContainers[index].style.display = 'none';
//             }
//         });
//     }

//     function populateProvinces(provinceDropdown, provinceContainer) {
//         clearOptions(provinceDropdown);

//         // Use the usStates array for populating provinces
//         for (var i = 0; i < usStates.length; i++) {
//             var opt = document.createElement('option');
//             opt.value = usStates[i][0];
//             opt.innerHTML = usStates[i][1];
//             provinceDropdown.appendChild(opt);
//         }

//         provinceContainer.style.display = '';
//     }

//     function clearOptions(selector) {
//         while (selector.firstChild) {
//             selector.removeChild(selector.firstChild);
//         }
//     }

//     // Attach the countryHandler to the change event for each country dropdown
//     countryDropdowns.forEach(function (countryDropdown) {
//         countryDropdown.addEventListener('change', countryHandler);
//     });
// });

// new address code
document.addEventListener("DOMContentLoaded", function () {
  var countryDropdown = document.getElementById("AddressCountryNew");
  var provinceDropdown = document.getElementById("AddressProvinceNew");
  var provinceContainer = document.getElementById(
    "AddressProvinceContainerNew"
  );

  // Set the default value to 'US'
  countryDropdown.value = "US";

  // Disable other country options in the dropdown
  var countryOptions = countryDropdown.querySelectorAll("option");
  countryOptions.forEach(function (option) {
    if (option.value !== "US") {
      option.disabled = true;
    }
  });

  var usStates = [
    ["AL", "Alabama"],
    ["AK", "Alaska"],
    ["AZ", "Arizona"],
    ["AR", "Arkansas"],
    ["CA", "California"],
    ["CO", "Colorado"],
    ["CT", "Connecticut"],
    ["DE", "Delaware"],
    ["FL", "Florida"],
    ["GA", "Georgia"],
    ["HI", "Hawaii"],
    ["ID", "Idaho"],
    ["IL", "Illinois"],
    ["IN", "Indiana"],
    ["IA", "Iowa"],
    ["KS", "Kansas"],
    ["KY", "Kentucky"],
    ["LA", "Louisiana"],
    ["ME", "Maine"],
    ["MD", "Maryland"],
    ["MA", "Massachusetts"],
    ["MI", "Michigan"],
    ["MN", "Minnesota"],
    ["MS", "Mississippi"],
    ["MO", "Missouri"],
    ["MT", "Montana"],
    ["NE", "Nebraska"],
    ["NV", "Nevada"],
    ["NH", "New Hampshire"],
    ["NJ", "New Jersey"],
    ["NM", "New Mexico"],
    ["NY", "New York"],
    ["NC", "North Carolina"],
    ["ND", "North Dakota"],
    ["OH", "Ohio"],
    ["OK", "Oklahoma"],
    ["OR", "Oregon"],
    ["PA", "Pennsylvania"],
    ["RI", "Rhode Island"],
    ["SC", "South Carolina"],
    ["SD", "South Dakota"],
    ["TN", "Tennessee"],
    ["TX", "Texas"],
    ["UT", "Utah"],
    ["VT", "Vermont"],
    ["VA", "Virginia"],
    ["WA", "Washington"],
    ["WV", "West Virginia"],
    ["WI", "Wisconsin"],
    ["WY", "Wyoming"],
    // Add more states as needed
  ];

  // Trigger the countryHandler manually to populate provinces based on the default country
  countryHandler();

  function countryHandler() {
    var opt = countryDropdown.options[countryDropdown.selectedIndex];
    var selectedCountry = opt.value;

    // Check if the selected country is 'US'
    if (selectedCountry === "US") {
      populateProvinces(usStates);
    } else {
      clearOptions(provinceDropdown);
      provinceContainer.style.display = "none";
    }
  }

  function populateProvinces(states) {
    clearOptions(provinceDropdown);

    for (var i = 0; i < states.length; i++) {
      var opt = document.createElement("option");
      opt.value = states[i][0];
      opt.innerHTML = states[i][1];
      provinceDropdown.appendChild(opt);
    }

    provinceContainer.style.display = "";
  }

  function clearOptions(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  }

  // Attach the countryHandler to the change event
  countryDropdown.addEventListener("change", countryHandler);
});

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button:not(.localization-selector)").forEach(
      (button) =>
        button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent)
      elementToFocus?.setAttribute("aria-expanded", false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    window.addEventListener("resize", this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
    window.removeEventListener("resize", this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset
        )}px`
      );
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );
  };
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector(".announcement-bar-slider");
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      );
      this.reducedMotion.addEventListener("change", () => {
        if (this.slider.getAttribute("data-autoplay") === "true")
          this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          "click",
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    if (this.querySelector(".slideshow__autoplay")) {
      this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
      this.sliderAutoplayButton.addEventListener(
        "click",
        this.autoPlayToggle.bind(this)
      );
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = "next") {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === "next" ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = "announcement-bar-slider--fade-in";
    const animationClassOut = "announcement-bar-slider--fade-out";

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext =
      (button === "next" && !isLastSlide) ||
      (button === "previous" && isFirstSlide);
    const direction = shouldMoveNext ? "next" : "previous";

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      )
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          "[value]",
          input.getAttribute("value")
        );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        );
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        );

        const volumePricingSource = html.getElementById(
          `Volume-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );

        const pricePerItemDestination = document.getElementById(
          `Price-Per-Item-${this.dataset.section}`
        );
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );

        const volumePricingDestination = document.getElementById(
          `Volume-${this.dataset.section}`
        );
        const qtyRules = document.getElementById(
          `Quantity-Rules-${this.dataset.section}`
        );
        const volumeNote = document.getElementById(
          `Volume-Note-${this.dataset.section}`
        );

        if (volumeNote) volumeNote.classList.remove("hidden");
        if (volumePricingDestination)
          volumePricingDestination.classList.remove("hidden");
        if (qtyRules) qtyRules.classList.remove("hidden");

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "hidden",
            skuSource.classList.contains("hidden")
          );
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle(
            "hidden",
            pricePerItemSource.classList.contains("hidden")
          );
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("hidden");

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "hidden",
            inventorySource.innerText === ""
          );

        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`
        );
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(
      `Price-Per-Item-${this.dataset.section}`
    );
    const volumeNote = document.getElementById(
      `Volume-Note-${this.dataset.section}`
    );
    const volumeTable = document.getElementById(
      `Volume-${this.dataset.section}`
    );
    const qtyRules = document.getElementById(
      `Quantity-Rules-${this.dataset.section}`
    );

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("hidden");
    if (inventory) inventory.classList.add("hidden");
    if (sku) sku.classList.add("hidden");
    if (pricePerItem) pricePerItem.classList.add("hidden");
    if (volumeNote) volumeNote.classList.add("hidden");
    if (volumeTable) volumeTable.classList.add("hidden");
    if (qtyRules) qtyRules.classList.add("hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

// common custom js

const LOCAL_STORAGE_WISHLIST_KEY = "shopify-wishlist";
const LOCAL_STORAGE_DELIMITER = ",";
const BUTTON_ACTIVE_CLASS = "active";
const GRID_LOADED_CLASS = "loaded";

const selectors = {
  button: "[button-wishlist]",
  grid: "[grid-wishlist]",
  productCard: ".product-card-nirali",
};

document.addEventListener("DOMContentLoaded", () => {
  initButtons();
  initGrid();
});

document.addEventListener("shopify-wishlist:updated", (event) => {
  console.log("[Shopify Wishlist] Wishlist Updated ✅", event.detail.wishlist);
  initGrid();
});

document.addEventListener("shopify-wishlist:init-product-grid", (event) => {
  console.log(
    "[Shopify Wishlist] Wishlist Product List Loaded ✅",
    event.detail.wishlist
  );
});

document.addEventListener("shopify-wishlist:init-buttons", (event) => {
  console.log(
    "[Shopify Wishlist] Wishlist Buttons Loaded ✅",
    event.detail.wishlist
  );
});

// const fetchProductCardHTML = (handle) => {
//   const productTileTemplateUrl = `/pages/wishlist?handle=${handle}&view=card`;
//   // const productTileTemplateUrl = `/products/${handle}?view=card`;
//   return fetch(productTileTemplateUrl)
//   // .then((res) => res.text()) console.log(res)
//     .then((res) => {
//     // Add console.log here
//       return res.text();
//     })
//   .then((res) => {
//        console.log(res);
//     const text = res;
//     const parser = new DOMParser();
//     const htmlDocument = parser.parseFromString(text, 'text/html');
//     const productCard = htmlDocument.documentElement.querySelector(selectors.productCard);
//     return productCard.outerHTML;
//   })
//   .catch((err) => console.error(`[Shopify Wishlist] Failed to load content for handle: ${handle}`, err));
// };

// const setupGrid = async (grid) => {
//   const wishlist = getWishlist();
//   const requests = wishlist.map(fetchProductCardHTML);
//   const responses = await Promise.all(requests);
//   const wishlistProductCards = responses.join('');
//   grid.innerHTML = wishlistProductCards;
//   grid.classList.add(GRID_LOADED_CLASS);
//   initButtons();

//   const event = new CustomEvent('shopify-wishlist:init-product-grid', {
//     detail: { wishlist: wishlist }
//   });
//   document.dispatchEvent(event);
// };

const fetchProductCardHTML = async (handle) => {
  const productTemplateUrl = `/pages/my-account`;
  try {
    const response = await fetch(productTemplateUrl);
    const html = await response.text();
    return html;
  } catch (error) {
    console.error(`Failed to load content for handle: ${handle}`, error);
    return "";
  }
};

const setupGrid = async (grid) => {
  const wishlist = getWishlist();
  // const requests = wishlist.map(fetchProductCardHTML);
  // const responses = await Promise.all(requests);

  if (wishlist.length > 0) {
    const wishlistProductCards = wishlist.map((handle) => {
      // You can customize the HTML structure for each wishlist item here
      return `
        <div class="wishlist-product-card">
          <a href="/products/${handle}" class="wishlist-product-card_link">
            <img src="/images/${handle}.jpg" alt="${handle}" class="wishlist-product-card__image"/>
            <p class="wishlist-product-card__title">${handle}</p>
            <!-- Add more details as needed -->
          </a>
          <button class="remove-from-wishlist" data-product-handle="${handle}">Remove from Wishlist</button>
        </div>
      `;
    });

    grid.innerHTML = wishlistProductCards.join("");
    grid.classList.add(GRID_LOADED_CLASS);

    //     const productCardTemplate = (cardProduct) => `
    //   <div class="card-wrapper product-card-wrapper underline-links-hover featured-product-card">
    //     <div class="card card-custom-border ">
    //       <div class="card__inner custom-card-inner justify-content-center">
    //         ${
    //           cardProduct.featured_media
    //             ? `<div class="card__media card-media-custom">
    //                 <div class="media media--transparent media--hover-effect media-transparent-custom">
    //                   <img
    //                     src="${cardProduct.featured_media | image_url: 'medium'}"
    //                     alt="${cardProduct.title | escape}"
    //                     class="motion-reduce"
    //                     loading="lazy"
    //                     width="${cardProduct.featured_media.width}"
    //                     height="${cardProduct.featured_media.height}"
    //                   >
    //                   ${
    //                     cardProduct.media[1] != null && cardProduct.show_secondary_image
    //                       ? `<img
    //                           src="${cardProduct.media[1] | image_url: 'medium'}"
    //                           alt=""
    //                           class="motion-reduce"
    //                           loading="lazy"
    //                           width="${cardProduct.media[1].width}"
    //                           height="${cardProduct.media[1].height}"
    //                         >`
    //                       : ''
    //                   }
    //                 </div>
    //               </div>`
    //             : ''
    //         }
    //         <div class="card__content">
    //           <div class="card__information">
    //             <h3 class="card__heading h5">
    //               <a href="${cardProduct.url}" class="full-unstyled-link feature-product-title">
    //                 ${cardProduct.title | escape}
    //               </a>
    //             </h3>
    //             <!-- Add more information as needed -->
    //           </div>
    //           <div class="card__badge ">
    //             ${
    //               !cardProduct.available
    //                 ? `<span class="badge badge--bottom-left ">
    //                     ${'products.product.sold_out' }
    //                   </span>`
    //                 : cardProduct.compare_at_price > cardProduct.price && cardProduct.available
    //                 ? `<span class="badge badge--bottom-left ">
    //                     ${'products.product.on_sale' }
    //                   </span>`
    //                 : ''
    //             }
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // `;

    // // Use the template in your loop
    // const wishlistProductCards = wishlist.map((cardProduct) => {
    //   return productCardTemplate(cardProduct);
    // });

    // grid.innerHTML = wishlistProductCards.join('');
    // grid.classList.add(GRID_LOADED_CLASS);
  }
  initButtons();
};

const setupButtons = (buttons) => {
  buttons.forEach((button) => {
    const productHandle = button.dataset.productHandle || false;
    if (!productHandle)
      return console.error(
        "[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist."
      );
    if (wishlistContains(productHandle))
      button.classList.add(BUTTON_ACTIVE_CLASS);
    button.addEventListener("click", (event) => {
      //      event.preventDefault(); // Prevent the default behavior (e.g., following a link)
      // event.stopPropagation();
      updateWishlist(productHandle);
      button.classList.toggle(BUTTON_ACTIVE_CLASS);
      $(".thumbnail-wishlist-btn-media").toggleClass("active");
      // return false;
    });
  });
};

const initGrid = () => {
  const grid = document.querySelector(selectors.grid) || false;
  if (grid) setupGrid(grid);
};

const initButtons = () => {
  const buttons = document.querySelectorAll(selectors.button) || [];
  if (buttons.length) setupButtons(buttons);
  else return;
  const event = new CustomEvent("shopify-wishlist:init-buttons", {
    detail: { wishlist: getWishlist() },
  });
  document.dispatchEvent(event);
};

const getWishlist = () => {
  const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
  return [];
};

const setWishlist = (array) => {
  const wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);

  const event = new CustomEvent("shopify-wishlist:updated", {
    detail: { wishlist: array },
  });
  document.dispatchEvent(event);

  return wishlist;
};

const updateWishlist = (handle) => {
  const wishlist = getWishlist();
  const indexInWishlist = wishlist.indexOf(handle);
  if (indexInWishlist === -1) wishlist.push(handle);
  else wishlist.splice(indexInWishlist, 1);
  return setWishlist(wishlist);
};

const wishlistContains = (handle) => {
  const wishlist = getWishlist();
  return wishlist.includes(handle);
};

const resetWishlist = () => {
  return setWishlist([]);
};

//my js
function addToWishlist(productId) {
  // Make an AJAX request to update the product's Wishlist metafield
  $.ajax({
    type: "POST",
    url: "/tools/add-to-wishlist",
    data: {
      productId: productId,
    },
    success: function (response) {
      alert("Product added to wishlist!");
    },
    error: function (error) {
      console.error("Error adding product to wishlist:", error);
    },
  });
}



 // for wishlist club 
// document.addEventListener("DOMContentLoaded", function() {
//  var baseUrl = window.location.origin;
//   if (window.location.href === (baseUrl)+'/apps/wishlist'){
//    const variantIds = [7499608359092,7499607507124];
//   fetch(`https://telloss.sprigstack.com/api/get-shopify-products-detail?ids=${JSON.stringify(variantIds)}`)
//       .then(response => response.json())
//       .then(data => {
//           // Handle the response from Shopify API
//           console.log(data);
//           // Now you have the inventory level for the product variant
//       })
//       .catch(error => {
//           console.error('Error fetching inventory level:', error);
//       });
//   }
// });

// document.addEventListener("DOMContentLoaded", function() {
//     var baseUrl = window.location.origin;
//     if (window.location.href === (baseUrl)+'/apps/wishlist'){
//         const productHandles  = ["coarse-ground-whole-muskrat-2-lb", "coarse-ground-whole-pork-2-lb"]; // Example product IDs

//         fetch(`https://telloss.sprigstack.com/api/get-shopify-products-detail?handles=${JSON.stringify(productHandles )}`)
//             .then(response => response.json())
//             .then(data => {
//                 // Handle the response from Shopify API
//                 console.log(data);

//                 // Update quantity for each product in the wishlist
//                 data.forEach(productData => {
//                    const productHandle = productData.products[0].handle; // Accessing handle directly from productData
//         const inventoryQuantity = productData.products[0].variants[0].inventory_quantity; // Assuming only one variant for simplicity
//                     const productCards = document.querySelectorAll(`.th-wl-product-item a[href*="${productHandle}"]`);
//    console.log('Product Handle:', productHandle);
//     console.log('Product Cards:', productCards);
//                     productCards.forEach(card => {
//                         // Check if the product handle matches the handle in the href attribute
//                         if (card.href.includes(productHandle)) {
//                             // Create the quantity input element
//                             const quantityInput = document.createElement('input');
//                             quantityInput.type = 'number';
//                             quantityInput.value = inventoryQuantity;
//                             quantityInput.classList.add('qut-val');
//                             quantityInput.setAttribute('id', `wishlist-input-${productHandle}-Default Title`);
//                             const quantityLabel = document.createElement('label');
//                             quantityLabel.setAttribute('for', `wishlist-input-${productHandle}-Default Title`);

//                             // Insert the quantity input element before the button
//                             const quantityBox = card.parentElement.querySelector('.th-wl-quantity-box');
//                             if (quantityBox) {
//                                 quantityBox.insertBefore(quantityInput, quantityBox.firstChild);
//                                 quantityBox.insertBefore(quantityLabel, quantityInput);
//                             }
//                         }
//                     });
//                 });
//             })
//             .catch(error => {
//                 console.error('Error fetching inventory level:', error);
//             });
//     }
// });


// working
// Check if the code has already been executed and if the URL matches
if (!window.wishlistObserverExecuted && window.location.href === (window.location.origin) + '/apps/wishlist') {
    window.wishlistObserverExecuted = true;

    document.addEventListener("DOMContentLoaded", function() {
        // Function to update inventory display for a specific product
        function updateInventoryDisplay(productHandle, inventoryQuantity) {
            const productCards = document.querySelectorAll(`.th-wl-product-item a[href*="${productHandle}"]`);

            productCards.forEach(card => {
                // Check if the product handle matches the handle in the href attribute
                const escapedProductHandle = productHandle.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                if (card.href.includes(escapedProductHandle)) {
                    // Check if the inventory display element already exists
                    const cardContainer = card.closest('.th-wl-product-item');
                    let inventoryDisplay = cardContainer.querySelector('.wishlist-inventory-display');
                    if (!inventoryDisplay) {
                        // Create an element to display inventory quantity below the title
                        inventoryDisplay = document.createElement('div');
                        inventoryDisplay.classList.add('wishlist-inventory-display');
                    }
                    if (inventoryQuantity > 0) {
                        inventoryDisplay.textContent = `${inventoryQuantity} in stock`;
                    } else {
                        inventoryDisplay.textContent = `0 in stock`;
                    }
                    // Find the title element
                    const titleElement = cardContainer.querySelector('.th-wl-product-title');
                    if (titleElement) {
                        // Append the inventory display below the title
                        titleElement.appendChild(inventoryDisplay);
                    }
                }
            });
        }

        // Select the target node
        const targetNode = document.body;

        // Options for the observer (which mutations to observe)
        const config = { childList: true, subtree: true };

        // Callback function to execute when mutations are observed
        const callback = function(mutationsList, observer) {
            // Check if the code has already processed mutations
            if (!window.wishlistProcessingMutations) {
                window.wishlistProcessingMutations = true;

                mutationsList.forEach(mutation => {
                    // Check if products were removed from the wishlist
                    if (mutation.removedNodes.length > 0) {
                        const removedProductHandles = Array.from(mutation.removedNodes)
                            .filter(node => node.nodeType === Node.ELEMENT_NODE && node.classList.contains('th-wl-product-item'))
                            .map(node => {
                                const anchor = node.querySelector('a');
                                if (anchor) {
                                    const href = anchor.getAttribute('href');
                                    return href.split('/').pop().split('?')[0];
                                }
                            })
                            .filter(handle => handle); // Remove any undefined handles

                        removedProductHandles.forEach(removedHandle => {
                            // Remove inventory display for removed products
                            const removedDisplayCards = document.querySelectorAll(`.th-wl-product-item a[href*="${removedHandle}"]`);
                            removedDisplayCards.forEach(card => {
                                const cardContainer = card.closest('.th-wl-product-item');
                                const inventoryDisplay = cardContainer.querySelector('.wishlist-inventory-display');
                                if (inventoryDisplay) {
                                    inventoryDisplay.remove();
                                }
                            });
                        });
                    }
                });

                // Select all anchor tags with class th-wl-product-item
                const productAnchors = document.querySelectorAll('.th-wl-product-item a');

                // Extract unique product handles from href attributes
                const productHandles = Array.from(productAnchors).map(anchor => {
                    const href = anchor.getAttribute('href');
                    return href.split('/').pop().split('?')[0];
                });

                // Fetch product details using the extracted handles
                fetch(`https://app.telloss.com/api/get-shopify-products-detail?handles=${JSON.stringify(productHandles)}`)
                    .then(response => response.json())
                    .then(data => {
                        // Update inventory display for each product
                        Object.entries(data).forEach(([handle, quantity]) => {
                            updateInventoryDisplay(handle, quantity);
                        });
                    })
                    .catch(error => {
                        console.error('Error fetching inventory level:', error);
                    })
                    .finally(() => {
                        // Reset flag to allow processing of mutations again
                        window.wishlistProcessingMutations = false;
                    });
            }
        };

        // Create an observer instance linked to the callback function
        const observer = new MutationObserver(callback);

        // Start observing the target node for configured mutations
        observer.observe(targetNode, config);
    });
}








   



// document.addEventListener("DOMContentLoaded", function() {
//     // Check if the current URL matches the desired URL
// var baseUrl = window.location.origin;
//    if (window.location.href === (baseUrl)+'/apps/wishlist'){
//         // Select the target node
//     const targetNode = document.body;

//     // Options for the observer (which mutations to observe)
//     const config = { childList: true, subtree: true };

//     // Callback function to execute when mutations are observed
//     const callback = function(mutationsList, observer) {
//         for(const mutation of mutationsList) {
//             if (mutation.type === 'childList') {
//                 // Check if th-wl-product-row is added to the DOM
//                 const productRow = document.querySelector('.th-wl-product-row');
//                 if (productRow) {
//                     // Modify the titles inside th-wl-product-item
//                     const productTitles = document.querySelectorAll('.th-wl-product-item .th-wl-product-title');
//                     productTitles.forEach(title => {
//                         // Retrieve product title from Liquid
//                         const liquidTitle = "{{ product.title }}"; // Assuming product.title is accessible in your Liquid context
//                         // Modify the title as needed
//                         title.innerHTML = liquidTitle;

//                         // Fetch product inventory dynamically
//                         const productId = title.getAttribute('data-product-id'); // Assuming you have some attribute to identify each product
//                         fetch('/products/' + productId + '.js')
//                             .then(response => response.json())
//                             .then(data => {
//                                 const inventoryCount = data.inventory_quantity; // Assuming the inventory quantity is available in the JSON response
//                                 const inventoryDisplay = inventoryCount > 0 ? 'In Stock' : 'Out of Stock';
//                                 const inventoryElement = document.createElement('p');
//                                 inventoryElement.textContent = inventoryDisplay;
//                                 title.parentNode.appendChild(inventoryElement);
//                             })
//                             .catch(error => {
//                                 console.error('Error fetching product inventory:', error);
//                             });
//                     });

//                     // Disconnect the observer once the changes are made
//                     observer.disconnect();
//                 }
//             }
//         }
//     };

//     // Create an observer instance linked to the callback function
//     const observer = new MutationObserver(callback);

//     // Start observing the target node for configured mutations
//     observer.observe(targetNode, config);

//     }
// });





